module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/Star.7357eca3.svg";